import auth from '@/auth';
import storage from './storage';
import { WECHAT_GRANT, WECHAT_JSSDK } from './types';

export default {
    [WECHAT_GRANT](state, payload) {
        if (payload.token) {
            auth.login(payload.token);
        }
        state.openid = payload.openid;
        storage.set(payload.openid);
    },
    [WECHAT_JSSDK](state, payload) {
        state.jssdk = payload;
    },
};



// WEBPACK FOOTER //
// ./src/store/wechat/mutations.js